import { Formik, Form } from 'formik';
import FormObserver from 'src/components/FormObserver';

const FormWrapper = ({
  onSubmit = () => {},
  initialValues = {},
  validationSchema,
  children,
  onChange = () => {},
  ...props
}) => {
  return (
    <Formik
      onSubmit={onSubmit}
      initialValues={initialValues}
      validationSchema={validationSchema}
      enableReinitialize
      {...props}
    >
      {(formProp) => {
        if (typeof children === 'function') {
          return (
            <Form onChange={onChange}>
              <FormObserver />
              <fieldset>{children(formProp)}</fieldset>
            </Form>
          );
        }
        return (
          <Form onChange={onChange}>
            <FormObserver />
            <fieldset>{children}</fieldset>
          </Form>
        );
      }}
    </Formik>
  );
};

export default FormWrapper;
